<template>

  <router-view :key="$route.fullPath"></router-view>

</template>
<script setup lang="ts">
</script>